
import axios from './rest-axios';

const getStaff = () => axios.get(`/manage/staff`);
const getStaffDetail = (id) => axios.get(`/manage/staff/${id}`);
const postStaff = (model) => axios.post(`/v1/staff`, model);
const postStaff2 = (model) => axios.post(`/manage/staff`, model);
const putStaff = (model) => axios.put(`/v1/staff/${model.id}`, model);
const putStaff2 = (model) => axios.put(`/manage/staff/${model.id}`, model);
const putStaffFile = (id, is_file) => axios.put(`/manage/staff/${id}/file`, {is_file});
const postStaffFromQYWX = () => axios.post(`/manage/staff/syncfromqxwx`);
const getStaffConfig = () => axios.get(`/manage/staff/extattr`);
const postStaffCoursesFee = (id, ids) => axios.post(`/manage/staff/${id}/courses_fee`, {
    ids: ids
});
const deleteStaffCoursesFee = (user_id, id) => axios.delete(`/manage/staff/${user_id}/courses_fee/${id}`);

const getnewStaffFromQYWX = () => axios.get(`/manage/staff/syncnewfromqxwx`);
const postimportStaffFromQYWX = (userids) => axios.post(`/manage/staff/importfromqxwx`, {userids});
const postimportDepartmentFromQYWX = () => axios.post(`/manage/departments/update`, {});
const resetPassword = (student_id, password) => axios.post(`/manage/staff/${student_id}/resetpassword`, {password});

export {
    getStaff,
    postStaff,
    putStaff,
    putStaffFile,
    postStaffFromQYWX,
    getStaffDetail,
    getStaffConfig,
    postStaff2,
    putStaff2,
    postStaffCoursesFee,
    deleteStaffCoursesFee,
    getnewStaffFromQYWX,
    postimportStaffFromQYWX,
    postimportDepartmentFromQYWX,
    resetPassword,
};
